<template>
<!-- w -45 h -45 -->
  <path d="M45 22.5C45 34.9264 34.9264 45 22.5 45C10.0736 45 0 34.9264 0 22.5C0 10.0736 10.0736 0 22.5 0C34.9264 0 45 10.0736 45 22.5Z" fill="white"/>
  <path d="M32.2184 32.3749H12.7813C10.9229 32.3749 9.75994 30.3648 10.6863 28.7537L20.4049 11.8518C21.3341 10.2358 23.6657 10.2358 24.5949 11.8518L34.3135 28.7537C35.2398 30.3648 34.0769 32.3749 32.2184 32.3749Z" stroke="#D41B1B" stroke-width="1.5" stroke-linecap="round"/>
  <path d="M22.5 17.875V22.7083" stroke="#D41B1B" stroke-width="1.5" stroke-linecap="round"/>
  <path d="M22.5 27.5526L22.5109 27.5405" stroke="#D41B1B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</template>
